export default [{ //登录
    path: '/adminloginKt9A3dEm2uW',
    component: (resolve) => {
        require(['../view/admin/login.vue'], resolve)
    },
    name: 'adminlogin',
}, {
    path: '/admin',
    component: (resolve) => {
        require(['../view/admin/layout/index.vue'], resolve)
    },
    name: 'admin',
    redirect: '/admin/index',
    children: [{ // 首页
            path: 'index',
            component: (resolve) => {
                require(['../view/admin/index/index.vue'], resolve)
            },
            name: 'index',
            meta: {
                adminlogin: true, //是否登录
            },
        }, { //用户中心
            path: 'admincameralist',
            component: (resolve) => {
                require(['../view/admin/camera/index.vue'], resolve)
            },
            name: 'admincameralist',
            meta: {
                adminlogin: true, //是否登录
            }
        },
        { //Management
            path: 'Management',
            component: (resolve) => {
                require(['../view/admin/Management/index.vue'], resolve)
            },
            name: 'Management',
            meta: {
                adminlogin: true, //是否登录
            }
        },
        { //相机列表
            path: 'usercenter',
            component: (resolve) => {
                require(['../view/admin/usercenter/index.vue'], resolve)
            },
            name: 'usercente',
            meta: {
                adminlogin: true, //是否登录
            },
        }, { //banner
            path: 'banner',
            component: (resolve) => {
                require(['../view/admin/myweb/banner.vue'], resolve)
            },
            name: 'banner',
            meta: {
                adminlogin: true, //是否登录
            },
        }, { //公司信息简介
            path: 'information',
            component: (resolve) => {
                require(['../view/admin/myweb/information.vue'], resolve)
            },
            name: 'information',
            meta: {
                adminlogin: true, //是否登录
            },
        }, {
            path: 'usercenter',
            component: (resolve) => {
                require(['../view/admin/usercenter/index.vue'], resolve)
            },
            name: 'usercenter',
            meta: {
                adminlogin: true, //是否登录
            },
        }
    ]
}]


// WEBPACK FOOTER //
// ./src/router/admin.js